var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pa-0"},[_c('person-form',{class:_vm.isMobile?'':'mt-6',attrs:{"uid":1,"model":"Person","is-config":""},on:{"update-company":_vm.updateCompany}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }